import { Button, DatePicker, Form, Modal, Select } from "antd";
import { useDispatch } from "react-redux";
import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { EmployeeRoleHistorySetup, getRoles } from "../../role/roleApis";
import { loadSingleStaff } from "../../../redux/rtk/features/user/userSlice";

const RoleAddSinglePopup = ({ list, setLoading }) => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [form] = Form.useForm();
  const dispatch = useDispatch();
  const { id } = useParams();
  const [rolesList, setRolesList] = useState(null);
  const { Option } = Select;

  useEffect(() => {
    getRoles()
      .then((data) => setRolesList(data))
      // .catch((error) => // console.log("Error loading roles:", error));
  }, []);

  const showModal = () => {
    setIsModalOpen(true);
  };

  const handleCancel = () => {
    setIsModalOpen(false);
    form.resetFields();
  };

  const onFinish = async (values) => {
    try {
      setLoading(true);
      const response = await dispatch(EmployeeRoleHistorySetup({
        ...values,
        RoleHistoryId:0,
        EmployeeId: id,
        DataStatus: 1,
      }));
      if (response.payload.message === "success") {
        dispatch(loadSingleStaff(id));
        setIsModalOpen(false);
        form.resetFields();
      }
    } catch (error) {
      // console.error("Error adding role history:", error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <Button type="primary" onClick={showModal} className="mb-4">
        Add New Role
      </Button>
      <Modal
        title="Add Role"
        open={isModalOpen}
        onCancel={handleCancel}
        footer={null}
      >
        <Form
          form={form}
          name="addRole"
          layout="vertical"
          onFinish={onFinish}
        >
          <Form.Item
            label="Role"
            name="RoleId"
            rules={[{ required: true, message: "Please select a role!" }]}
          >
            <Select 
              placeholder="Select role" 
              allowClear
              showSearch
              optionFilterProp="children"
              filterOption={(input, option) =>
                option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
              }
            >
              {rolesList?.map((role) => (
                <Option key={role.RoleId} value={role.RoleId}>
                  {role.RoleName}
                </Option>
              ))}
            </Select>
          </Form.Item>
          <Form.Item
            label="Effective From"
            name="EffectedFrom"
            rules={[{ required: true, message: "Please enter the effective date!" }]}
          >
            <DatePicker />
          </Form.Item>
           <Form.Item
            label="Effective To"
            name="EffectedTo"
          >
            <DatePicker />
          </Form.Item>
          <Form.Item>
            <Button type="primary" htmlType="submit">
              Add
            </Button>
          </Form.Item>
        </Form>
      </Modal>
    </>
  );
};

export default RoleAddSinglePopup;